import { shallowMount } from "@vue/test-utils";
import ThankyouPage from "@/mixins/thankyou-page";

describe("ThankyouPage Component", () => {
  let Component;
  let wrapper;

  beforeEach(() => {
    Component = {
      render() {},
      mixins: [ThankyouPage],
      props: {}
    };
    wrapper = shallowMount(Component);
  });

  it("Renders del component ThankyouPage", () => {
    expect(wrapper).toBeDefined();
  });

  it("Debe de establecer el valor por defecto", () => {
    expect(wrapper.text()).toContain("");
  });

  it("Debe devolver vacío si getDatosPersonales no tiene datos", () => {
    expect(wrapper.vm.domicilio).toBe("");
  });

  it("Debe devolver los datos de la dirección", () => {
    wrapper.vm.$store.getters.getDatosPersonales = () => ({
      domicilioParticular: {
        calle: "Buenos aires",
        numero: "1234",
        localidad: "Capital Federal",
        provincia: "02"
      }
    });
    expect(wrapper.vm.domicilio).toBe(
      "Buenos aires 1234, Capital Federal, BUENOS AIRES"
    );
  });
});
